module.exports = __webpack_public_path__ + "img/paraf.065689d5.jpg";